<div mat-dialog-title fxLayout="row">
  <h1>{{ dialogData?.title }}</h1>
</div>

<div mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit(form)" fxLayout="column">
    <wai-form-input
      appearance="outline"
      fxFlex
      label="{{ 'INTL_NAME' | translate }}"
      [control]="asFormControl(form.get('name'))"
    ></wai-form-input>

    <div fxLayoutAlign="end center">
      <button type="button" mat-button [mat-dialog-close]="null">
        <mat-icon>block</mat-icon> <span class="button-label">{{ 'INTL_CANCEL' | translate }}</span>
      </button>
      <button type="submit" mat-button color="primary" [disabled]="form.invalid">
        <mat-icon>check</mat-icon> <span class="button-label">{{ 'INTL_SAVE' | translate }}</span>
      </button>
    </div>
  </form>
</div>
